import type { CreatorProfile } from '@/types/portal';

/** Can the agency hire and pay this creator now? Both KYC and the Twiva wallet have to be done. */
export function readiness(creator: CreatorProfile): { ready: boolean; label: string } {
  const kycDone = /complete|approved|verified/i.test(creator.kycStatus);
  const walletDone = /active/i.test(creator.walletStatus) && !/inactive/i.test(creator.walletStatus);
  if (kycDone && walletDone) return { ready: true, label: 'Ready to hire' };
  const missing = [kycDone ? '' : creator.kycStatus || 'KYC not done', walletDone ? '' : creator.walletStatus || 'No wallet']
    .filter(Boolean)
    .join(' · ');
  return { ready: false, label: `Not ready: ${missing}` };
}

/**
 * A plain-words read of an engagement rate. Rough industry rule of thumb: 1–3% is usual,
 * above 3% is good, above 6% is high.
 */
export function engagementVerdict(rate: number): { label: string; tone: string } {
  if (rate >= 6) return { label: 'High', tone: 'text-accent-700' };
  if (rate >= 3) return { label: 'Good', tone: 'text-accent-700' };
  if (rate >= 1) return { label: 'Average', tone: 'text-secondary-800' };
  return { label: 'Low', tone: 'text-primary-700' };
}

/** The platform with the most average views per post, if any platform reports them. */
export function bestViews(creator: CreatorProfile): { platform: string; avgViews: number } | null {
  const best = [...creator.platforms].filter((p) => p.avgViews > 0).sort((a, b) => b.avgViews - a.avgViews)[0];
  return best ? { platform: best.platform, avgViews: best.avgViews } : null;
}
